module.exports = __webpack_public_path__ + "static/pattern-c812c2634190faefc088b98d00187315.svg";